<section class="owners o-page">
	<h1
		class="c-page-heading o-page__heading"
		data-quat="value_otherNamesHeading"
	>
		<!-- FIXME: Update to use petname --> Add a Vet Clinic for {{ petName$ | async }}
	</h1>
	<form
		[formGroup]="ownersForm"
		class="owners__form o-page__content"
	>
		<section class="c-radio-group">
			<p
				id="otherOwnersDescription"
				class="c-radio-group__description"
			>
				<span
					class="c-radio-group__description-heading"
					data-quat="value_otherOwnersSubheading"
				>
					<!-- FIXME: Update to use new values --> Has anyone else taken {{ petName$ | async }} to {{
					clinicName$ | async }}
				</span>
				<!-- TODO: Make this dynamic -->
				<span class="c-radio-group__description-subheading">This could be before you adopted them or visits with
					other family members.</span>
			</p>
			<div
				role="presentation"
				class="c-radio-group__controls"
			>
				<!-- To programatically click these you have to query the input inside of the radio -->
				<mat-radio-group
					formControlName="hasOtherOwners"
					class="owners__radio-group"
					aria-labelledby="otherOwnersDescription"
				>
					<mat-radio-button
						[value]="true"
						data-quat="input_hasOtherOwnersYes"
					>Yes</mat-radio-button>
					<mat-radio-button
						[value]="false"
						data-quat="input_hasOtherOwnersNo"
					>No</mat-radio-button>
				</mat-radio-group>
			</div>
		</section>
		<div
			[hidden]="hideOwnersInput"
			role="presentation"
			class="c-input-group owners__group-names"
		>
			<label
				for="otherOwners"
				class="c-input-group__label"
				data-quat="label_ownersList"
			>List other owners' names</label>
			<input
				formControlName="otherOwners"
				type="text"
				name="otherOwners"
				id="otherOwners"
				class="c-input-group__input owners__input-owners"
				maxlength="100"
				data-quat="input_ownersList"
			>
		</div>
		<button
			[disabled]="ownersForm.invalid"
			class="c-cta owners__cta"
			type="button"
			data-quat="action_nextStep"
			(click)="nextStep()"
		> Next </button>
	</form>
	<section class="c-workflow-actions o-page__actions">
		<mv-back-button
			class="c-workflow-actions__item m--start"
			(click)="stepBack()"
		></mv-back-button>
		<mv-cancel-button
			class="c-workflow-actions__item m--end"
			(click)="cancel()"
		></mv-cancel-button>
	</section>
</section>